export default __webpack_public_path__ + "fonts/25661745f5d15fca1402b948d687a315.eot";